import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getRemarkConfig(params) {
  return request({
    url: URL.sys.queryRemarkConfig,
    method: 'get',
    params: { 'officeId': params }
  })
}

export function saveRemarkConfig(data) {
  return request({
    url: URL.sys.saveForRemarkConfig,
    method: 'post',
    data
  })
}

export function getInitializationConfig(data) {
  return request({
    url: URL.sys.initializationConfig,
    method: 'get',
    data
  })
}

export function getLatestInvoiceRemark(data) {
  return request({
    url: URL.act.invoice.getLatestInvoiceRemark,
    method: 'post',
    data
  })
}

export function updateInvoiceRemarkByConfig(data) {
  return request({
    url: URL.act.invoice.updateInvoiceRemarkByConfig,
    method: 'post',
    data
  })
}
